/**
 * Shared connection verification utilities
 */

export async function verifyConnection({
  connectionId,
  verificationStep,
  formData,
  connectionType,
}) {
  const verifyFormData = new FormData();
  for (let [key, value] of formData.entries()) {
    if (
      key !== "connection_action" &&
      key !== "verification_step" &&
      key !== "_method"
    ) {
      verifyFormData.append(key, value);
    }
  }
  verifyFormData.set("connection[type]", connectionType);
  if (verificationStep) {
    verifyFormData.set("verification_step", verificationStep);
  }

  const verifyResponse = await fetch(
    `/admin/datacloud/connections/${connectionId}/verify_credentials`,
    {
      method: "POST",
      body: verifyFormData,
      headers: {
        Accept: "application/json",
      },
    },
  );

  if (!verifyResponse.ok) {
    const verifyData = await verifyResponse.json();
    return {
      success: false,
      error: {
        errorMessage:
          verifyData.error_message ||
          "There was an error verifying the connection",
        errorLink: verifyData.error_link || "",
        curlCommand: verifyData.curl_command || "",
        tokenForCurl: verifyData.token_for_curl || "",
        rawMessage: verifyData.raw_message || "",
      },
    };
  }
  return { success: true };
}

export async function runStepByStepVerification({
  connectionId,
  verificationSteps,
  formData,
  connectionType,
  onStepChange,
}) {
  const totalSteps = verificationSteps.length;
  for (let i = 0; i < totalSteps; i++) {
    const step = i + 1;
    const stepLabel = verificationSteps[i].label;
    if (onStepChange) {
      onStepChange({ currentStep: step, totalSteps, stepLabel });
    }
    const result = await verifyConnection({
      connectionId,
      verificationStep: step,
      formData,
      connectionType,
    });
    if (!result.success) {
      return result;
    }
  }
  return { success: true };
}
